























































import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line no-unused-vars
import { Emit, Prop, Watch } from 'vue-property-decorator';
// eslint-disable-next-line no-unused-vars
import Node from '../../models/Node';
import BInputLimited from '@/components/input_limited/BInputLimited.vue';
import BTextareaLimited from '@/components/input_limited/BTextareaLimited.vue';
import store from '@/store/store';

function simplifyNode(node: Node)
{
    return {
        nodeid: node.nodeid,
        name: node.name
    };
}

function jsonSimplifyFunc(name: string, val: any)
{
    if (!val) return val;
    if (val.$vue || val.$refs || val.props || (val.data && val.data.$route)) return undefined;

    if (!val.length && val.forEach)
    {
        let res : any = {};
        val.forEach((val: any, k: any) => 
        {
            res[k] = val;
        });
        return res;
    }

    if (name == 'lastSelected' || name == 'selected')// || name == 'selected')
    {
        if (val.nodeid)
        {
            return simplifyNode(val);
        }
        //return undefined;
    }
    
    if (name == 'relatedArray')
    {
        if (val && val.length && val.length > 0)
        {
            const typedVal = val as Node[];
            return typedVal.map((a)=>
            {
                return simplifyNode(a);
            });
        }
        return val;
    }
    return val;
}

function hasCycle(object: any, name: string, stack: any[], filter?: Function | undefined) : boolean | number
{
    try
    {
        const type = typeof(object);
        if (filter)
        {
            object = filter(name, object);
        }

        let tabs = '';
        for(let i = 0; i < stack.length; ++i)
        {
            tabs += '  ';
        }
        
        if (object == undefined || object == null)
        {
            console.log(`${tabs}  => ${typeof(object)}`);
            return false;
        }
        if (type == 'object')
        {
            if (stack.includes(object))
            {
                console.error(`Cycle found @ ${name}!  Stack trace follows (length == ${stack.length})...`);
                return true;
            }

            console.log(tabs + "{");
            stack.push(object);
            {
                let subTabs = tabs + '  ';
                if (object.forEach)
                {
                    let cycleFound : number | boolean = false;
                    object.forEach((val: any, k: any) => 
                    {
                        if (cycleFound) return;

                        console.log(`${subTabs}${k} [${typeof(val)}] ${val}`);
                        if (cycleFound = hasCycle(val, k, stack, filter))
                        {
                            console.error(subTabs + k);
                            return true;
                        }
                    });
                    if (cycleFound) return cycleFound;
                }
                else
                {
                    for (let k of Object.keys(object))
                    {
                        const val = object[k];
                        if (val && val.forEach)
                        {
                            console.log(`${subTabs}> ${k} [${typeof(val)}] ${val}`);
                        }
                        else
                        {
                            console.log(`${subTabs}${k} [${typeof(val)}] ${val}`);
                        }

                        // eslint-disable-next-line no-unused-vars
                        if (hasCycle(val, k, stack, filter))
                        {
                            console.error(subTabs + k);
                            return true;
                        }
                    }
                }
            }
            stack.pop();
            console.log(tabs + "}");
        }
        if (stack.length == 0)
        {
            console.log('search complete');
        }
    }
    catch(err)
    {
        console.error(err);
        return -1;
    }
    return false;
}

@Component({
    components: {
        BInputLimited,
        BTextareaLimited
    }
})
export default class SupportForm extends Vue
{
    submitting = false;
    message = '';
    contactEmail = '';
    errors: string[] = []

    mounted()
    {
       	setTimeout(() => 
        {
            this.$nextTick(() =>
            {
                (this.$refs.messageField as HTMLElement).focus();
            });
        }, 50);
    }

    get isLTI()
    {
        return store.state.isLTI;
    }

    close()
    {
        this.$emit("close");
    }

    generateStateJson()
    {
        // TODO: It would be really nice if we had static typing here...
        const state = this.$store.state;
        state.consoleCache = 
        { 
            logCache: (window as any).logCache, 
            warnCache: (window as any).warnCache, 
            errorCache: (window as any).errorCache 
        };
        state.userAgent = navigator.userAgent;
        state.vendor = navigator.vendor;
        const uaData = (navigator as any).userAgentData;
        state.userAgentData = (uaData && uaData.toJSON) ? uaData.toJSON() : {};

        /*
        alert('checking for cycles')
        if (hasCycle(state, '[::root::]', [], jsonSimplifyFunc))
        {
            alert('cycle found')
            return null;
        }
        alert('no cycles found')
        //*/

        return JSON.stringify(state, (name, val)=>
        {
            //console.log(name);
            return jsonSimplifyFunc(name, val);
        });
    }

    async submit()
    {
        if (this.submitting) return;
        if (this.isLTI && (this.contactEmail.length === 0 || !this.contactEmail.includes('@'))) 
        {
            this.errors.push('You must provide a valid contact email');
            return;
        }

        this.submitting = true;
        this.errors.length = 0;
        const state = this.generateStateJson();
        try
        {
            await this.$http.post('support', {
                message: this.message,
                contact_email: this.contactEmail,
                state
            });

            this.$root.$bvToast.toast('Support request submitted, our support team will contact you soon!',
                {
                    title: 'Support Request Submitted',
                    variant: 'success',
                    autoHideDelay: 5000
                });

            this.close();
        }
        catch(ex)
        {
            console.error(ex);
            const resp = ex.response;
            if (resp)
            {
                this.errors.push(resp.data.error);
            }
        }
        this.submitting = false;
    }

    onSubmit(ev : Event)
    {
        ev.preventDefault();
        this.submit();
    }
}
